"use strict";

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.object.assign.js");

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.RocheTab = void 0;

var _react = _interopRequireDefault(require("react"));

var _Tab = _interopRequireDefault(require("@material-ui/core/Tab"));

var _utils = require("../utils");

var _tab = require("./tab.style");

var _core = require("../core");

var _excluded = ["classes"],
    _excluded2 = ["focusVisible"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/** Important **
 * To be able to use props of such a Material-UI component on their own, props
 * should be used with type arguments. Otherwise, the component prop will not
 * be present in the props of the Material-UI component.
 * https://material-ui.com/guides/typescript/#usage-of-component-prop
 **/
var RocheTabInner = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var classes = props.classes,
      restProps = _objectWithoutProperties(props, _excluded);

  var _mergeClasses = (0, _utils.mergeClasses)((0, _tab.useStyles)(), classes),
      focusVisibleClass = _mergeClasses.focusVisible,
      innerClasses = _objectWithoutProperties(_mergeClasses, _excluded2);

  var rippleClasses = (0, _tab.useRippleStyles)();
  return /*#__PURE__*/_react["default"].createElement(_Tab["default"], _extends({
    ref: ref,
    classes: innerClasses,
    focusVisibleClassName: focusVisibleClass,
    TouchRippleProps: {
      classes: rippleClasses
    }
  }, restProps));
});

RocheTabInner.displayName = (0, _core.rochePrefix)('Tab');
RocheTabInner.defaultProps = {
  disableFocusRipple: true
};
/**
 * Tabs make it easy to explore and switch between different views
 */

var RocheTab = RocheTabInner;
exports.RocheTab = RocheTab;
var _default = RocheTab;
exports["default"] = _default;